import Vue from 'vue'
import {
  SET_CREDENTIALS_RECORD,
  RESET_CREDENTIALS_RECORD,
  CHANGE_LOADING,
  SET_ERROR,
  SET_HAS_ERROR,
} from './mutations-types'
import { unique, } from './helpers'

export default {

  [SET_CREDENTIALS_RECORD] (state, { credentials, lei, }) {
    const values = [ ...state.credentials, ...credentials.data, ]
    const results = unique(values)
    state.lei = lei
    state.credentials = [ ...results, ]
    state.pagination = credentials.meta.page
  },

  [RESET_CREDENTIALS_RECORD] (state) {
    state.credentials = []
    state.pagination = null
  },

  [CHANGE_LOADING] (state, value) {
    state.loading = value
  },

  [SET_ERROR] (state, value) {
    state.error = value
  },

  [SET_HAS_ERROR] (state, value) {
    state.hasErrors = value
  },

}



// WEBPACK FOOTER //
// ./src/store/modules/credential/mutations.js